import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useRef } from "react";

function FlashModal({ onComplete }) {
    const flashRef = useRef(null);

    useGSAP(() => {
        gsap.to(flashRef.current, {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.in',
            onComplete: onComplete,
        })
    }, []);

    return (
        <div ref={flashRef} className="absolute h-screen w-screen bg-neutral-200 z-[100] flex flex-col items-center justify-center gap-2 overflow-auto"></div>
    );
}

export default FlashModal;